/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const SidebarCollapseSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 20"
  >
    <path
      fill="currentColor"
      d="M1.5 20c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 010 18.5c0-.417.146-.77.437-1.063A1.446 1.446 0 011.5 17c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063A1.446 1.446 0 011.5 20zm0-8.5c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 010 10c0-.417.146-.77.437-1.063A1.447 1.447 0 011.5 8.5c.417 0 .77.146 1.063.438C2.853 9.229 3 9.582 3 10c0 .417-.146.77-.438 1.063A1.446 1.446 0 011.5 11.5zm0-8.5c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 010 1.5C0 1.083.146.73.437.437A1.447 1.447 0 011.5 0c.417 0 .77.146 1.063.438C2.853.728 3 1.083 3 1.5c0 .417-.146.77-.438 1.063A1.447 1.447 0 011.5 3zM9.5 6l4 4.5-4 4.5V6z"
    ></path>
  </svg>
);

export const SidebarCollapseIcon = (props) => <Icon component={SidebarCollapseSvg} {...props} />;
